// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"wrap-1p4cAHYF clearfix"};